(g => { var h, a, k, p = "The Google Maps JavaScript API", c = "google", l = "importLibrary", q = "__ib__", m = document, b = window; b = b[c] || (b[c] = {}); var d = b.maps || (b.maps = {}), r = new Set, e = new URLSearchParams, u = () => h || (h = new Promise(async (f, n) => { await (a = m.createElement("script")); e.set("libraries", [...r] + ""); for (k in g) e.set(k.replace(/[A-Z]/g, t => "_" + t[0].toLowerCase()), g[k]); e.set("callback", c + ".maps." + q); a.src = `https://maps.googleapis.com/maps/api/js?` + e; d[q] = f; a.onerror = () => h = n(Error(p + " could not load.")); a.nonce = this.nonce; m.head.append(a) })); d[l] ? console.warn(p + " only loads once. Ignoring:", g) : d[l] = (f, ...n) => r.add(f) && u().then(() => d[l](f, ...n)) })
    ({ key: "AIzaSyCont3ygDVGMibB350EEv99mWakqpkX2Vk", v: "weekly" });

(function ($, window, document) {
    let root = document.documentElement;
    var $win = $(window);
    var $doc = $(document);
    var $body = $("body");
    var $header = $(".header");
    var $headerBar = $header.find(".header__main");
    var winWidth = $win.outerWidth();
    var winHeight = $win.outerHeight();
    var headerHeight = $header.outerHeight();
    var headerBarHeight = $headerBar.outerHeight();
    let winScrollHeight = $win.scrollTop();

    const counters = [];
    const countOptions = {
        startVal: 0,
        separator: ",",
        decimal: ",",
        duration: 3,
    };

    //On Clicks


    $(".js-toggle-search").on("click", function (e) {
        e.preventDefault();

        /*
        var $this = $(this);
        var $controls = $("#" + $this.attr("aria-controls"));
        var has_class = $body.hasClass("is-search-open");

        toggleAriaExpanded(this, !has_class);
        $body.toggleClass("is-search-open", !has_class);

        if (has_class) {
            $controls.stop().fadeOut(300);
        } else {
            $controls.stop().fadeIn(300);
        }*/

        $('.search-modal').addClass('is-visible');
    });

    // Close search modal when clicking outside the container
    $('.search-modal').on('click', function (e) {
        if (e.target === this) {
            $(this).removeClass('is-visible');
        }
    });

    $('.js-open-search-filters').on('click', function (e) {
        e.preventDefault();
        $('.search-filter-container')
            .addClass('is-open');

        setTimeout(() => {
            $('.search-filter-container')
                .addClass('is-visible');
        }, 1);

        $('body').addClass('no-scroll');
    });

    $('.js-close-search-filters').on('click', function (e) {
        e.preventDefault();
        $('.search-filter-container')
            .removeClass('is-visible');
        setTimeout(() => {
            $('.search-filter-container')
                .removeClass('is-open');
        }, 400);

        $('body').removeClass('no-scroll');
    });

    $(".js-nav-trigger").on("click", function (e) {
        e.preventDefault();

        var $this = $(this);
        var $controls = $("#" + $this.attr("aria-controls"));
        var has_class = $body.hasClass("is-nav-open");

        toggleAriaExpanded(this, !has_class);
        toggleTabIndex($controls, !has_class);

        $body.toggleClass("is-nav-open", !has_class);
    });


    $doc.on('click', '.js-close-popup', function (e) {
        e.preventDefault();

        var $this = $(this);
        // Find parent section--popup and fade out
        $this.closest('.section--popup').fadeOut();
    })

    $(".nav li > a > .nav__arrow").on("click", (e) => {
        if ($(window).width() > 1365) return;
        let $this = $(e.currentTarget);
        e.preventDefault();
        $this
            .parents("li")
            .toggleClass("is-dd-expanded")
            .find(".nav__dd")
            .slideToggle();
    });

    $(".nav .nav__title .nav__arrow").on("click", (e) => {
        if ($(window).width() > 1365) return;
        let $this = $(e.currentTarget);
        e.preventDefault();
        $this
            .parents(".nav__title")
            .parent()
            .toggleClass("is-dd-inner-expanded")
            .find(".nav__content")
            .slideToggle();
    });

    $(".js-link-more").on("click", (e) => {
        e.preventDefault();
        var $this = $(e.currentTarget);
        var $id = $($this.data("target"));

        if (!$id.length) {
            return;
        }

        if (!$this.hasClass("is-active")) {
            toggleAriaExpanded($(".js-link-more.is-active"), false);
            $(".js-link-more.is-active").removeClass("is-active");
            $(".content-more-holder").stop().slideUp();
        }

        if (!$this.parent(".article-content-more").length) {
            $this.toggleClass("is-active");
            $id.stop().slideToggle();

            toggleAriaExpanded($this, $this.hasClass("is-active"));
        }
    });


    let timeoutId = null;

    $doc.on({
        mouseenter: function () {
            // Check if the screen width is 767px or wider
            if ($(window).width() < 767) return;

            let $this = $(this);
            let $target = $($this.attr("data-hover-image-target"));
            let image = $this.attr("data-hover-image");

            if (timeoutId !== null) {
                clearTimeout(timeoutId);
            }

            // Check if the target img has a picture parent
            let $pictureParent = $target.parent('picture');
            if ($pictureParent.length) {
                // Store original values for restoration
                if (!$pictureParent.data('original-srcsets')) {
                    let originalSrcsets = [];
                    $pictureParent.find('source').each(function () {
                        originalSrcsets.push($(this).attr('srcset'));
                    });
                    $pictureParent.data('original-srcsets', originalSrcsets);
                }

                // Update all source srcset attributes
                $pictureParent.find('source').each(function () {
                    $(this).attr('srcset', image);
                });
            }

            $target.attr('src', image);
            $target.attr('srcset', image);
            $target.addClass("active");
        },
        mouseleave: function () {
            // Check if the screen width is 767px or wider
            if ($(window).width() < 767) return;

            let $this = $(this);
            let $target = $($this.attr("data-hover-image-target"));

            // Check if the target img has a picture parent
            let $pictureParent = $target.parent('picture');
            if ($pictureParent.length) {
                // Restore original source srcset values
                let originalSrcsets = $pictureParent.data('original-srcsets');
                if (originalSrcsets) {
                    $pictureParent.find('source').each(function (index) {
                        if (originalSrcsets[index]) {
                            $(this).attr('srcset', originalSrcsets[index]);
                        }
                    });
                }
            }

            timeoutId = setTimeout(function () {
                $target.removeClass("active");
            }, 2000);
        }
    }, '[data-hover-image]');

    $(document).on('click', '.menu-item-has-children > a[href="#"]', function (e) {
        e.preventDefault();
    })

    $(document).on('click', '.nav-item-mega-menu > .nav__dd > .sub-menu .nav__title a[href="#"]', function (e) {
        e.preventDefault();
    })


    $(".block-video:not(.is-active) .block__media").on("click", (e) => {
        e.preventDefault();
        let $this = $(e.currentTarget);
        let $videoHolder = $this.parent();
        let $iframe = $videoHolder.find("iframe");
        let is_playing = $videoHolder.hasClass("is-active");

        $videoHolder.toggleClass("is-active", !is_playing);
        $this
            .find("button")
            .attr("aria-pressed", !is_playing ? "true" : "false");

        if ($iframe.length) {
            if ($iframe.attr("src").search("youtube") > 0) {
                var message = {
                    event: "command",
                    func: is_playing ? "pauseVideo" : "playVideo",
                };
            } else if ($iframe.attr("src").search("vimeo") > 0) {
                var message = {
                    method: is_playing ? "pause" : "play",
                };
            }

            efront_post_message_to_iframe($iframe, message);
        } else {
            let $embed = $videoHolder.find("video");

            if ($embed.length) {
                if (is_playing) {
                    $embed[0].play();
                } else {
                    $embed[0].pause();
                }
            }
        }
    });

    function efront_post_message_to_iframe($iframe, message) {
        if (!$iframe.length || typeof message !== "object") {
            return null;
        }

        $iframe[0].contentWindow.postMessage(
            JSON.stringify(message),
            $iframe[0].src
        );
    }

    // Counters
    function initCounters() {
        $(".js-counter").each(function () {
            const id = $(this).attr("id");
            const endValue = $(this).attr("data-end");

            counters.push(new countUp.CountUp(id, endValue, countOptions));
        });
    }

    function checkCounters() {
        if (counters.length > 0) {
            for (var i = 0; i < counters.length; i++) {
                if ($(counters[i].el).hasClass("is-animated")) {
                    if (!counters[i].error) {
                        counters[i].start();
                    }
                }
            }
        }
    }

    // Tabbed Sections

    $doc.on('click', ".js-tabs .section__tabs--buttons .btn", function (e) {
        e.preventDefault()

        let $this = $(this);
        let $tabs = $this.parents('.js-tabs').eq(0).find('.js-tab');
        let $buttons = $this.siblings('.btn');

        $tabs.removeClass("active");
        $buttons.removeClass("active");
        $this.addClass('active');

        $('.js-tab[id="' + $this.attr('data-target') + '"]').addClass('active');
    });


    // Text to speech
    $doc.on('click', '.js-text-speech', function (e) {
        e.preventDefault();

        let $this = $(this);
        if ($this.find('audio').length) {
            $('audio').each(function () {
                $("#" + $(this).attr('id'))[0].pause();
            });

            $this.find('audio')[0].muted = false;
            $this.find('audio')[0].play();
        } else {
            if ($this.attr('data-text').length) {
                textToVoice($this.attr('data-text'));
            }
        }

    })

    // Animate on Scroll

    let animateOnScroll = () => {
        $(".js-animate").each((index, element) => {
            let $this = $(element);

            // Skip page balloon animation if it has already played this session.
            if ($this.hasClass('page-animate')) {
                if (sessionStorage.getItem('seenPageBalloonAnimation')) {
                    return;
                } else {
                    sessionStorage.setItem('seenPageBalloonAnimation', 1);
                }
            }

            let animateStart = $this.attr("data-start");
            let sectionTop = $this.offset().top;
            let sectionHeight = $this.outerHeight();
            let scrollTop = $win.scrollTop();
            let scrollBottom = scrollTop + $win.outerHeight();
            let sectionStartPosition = sectionHeight * animateStart;

            if (sectionTop + sectionStartPosition < scrollBottom) {
                $this.addClass("is-animated");
            }
        });
    };

    // Animate Confetti

    $(".confetti:not(.confetti-once-per-session) path").each((index, element) => {
        let randomNumb = Math.random();
        let $element = $(element);
        let elementOffsetTop = ($element.offset().top / winWidth) * -100;

        element.style.setProperty("--offset-top", elementOffsetTop + "vw");
        element.classList.add("measured");

        randomNumb = randomNumb < 0.5 ? randomNumb + 1 : randomNumb;
        randomNumb *= 1.3;
        element.style.setProperty("--rnd-nmb", randomNumb);
    });

    $(".confetti.confetti-once-per-session").each((i, el) => {
        if (sessionStorage.getItem('seenConfettiOncePerSessionAnimation')) {
            return;
        } else {
            sessionStorage.setItem('seenConfettiOncePerSessionAnimation', 1);
        }

        $(el).find("path").each((index, element) => {
            let randomNumb = Math.random();
            let $element = $(element);
            let elementOffsetTop = ($element.offset().top / winWidth) * -100;

            element.style.setProperty("--offset-top", elementOffsetTop + "vw");
            element.classList.add("measured");

            randomNumb = randomNumb < 0.5 ? randomNumb + 1 : randomNumb;
            randomNumb *= 1.3;
            element.style.setProperty("--rnd-nmb", randomNumb);
        });
    });

    //Animate Hero Balloons

    $win.on("load", function () {
        // Skip hero balloon animation if it has already played this session.
        if (sessionStorage.getItem('seenHeroBalloonAnimation')) {
            var durationOverride = 0; // 0 = skip to end | 1 = full duration (it is a multiplier).
        }

        $(".hero-animated .hero__media .balloon").each((index, element) => {
            let $element = $(element);
            let elementOffsetTop = $element.offset().top;
            winScrollHeight = $win.scrollTop();
            let scrollAvans = (
                (winHeight + winScrollHeight) /
                (winWidth * 1.76) /
                0.39333
            ).toFixed(4);

            if (winWidth < 1200) {
                scrollAvans = 1;
            }

            if (typeof durationOverride !== 'undefined') {
                scrollAvans = durationOverride;
                element.style.setProperty('transition-delay', '0s');
            }

            element.classList.add("measured");
            element.style.setProperty(
                "--element-offset-top",
                elementOffsetTop + "px"
            );
            element.style.setProperty(
                "--win-scroll-height",
                winScrollHeight + "px"
            );

            element
                .closest("svg")
                .style.setProperty("--element-speed", scrollAvans);

            setTimeout(function () {
                $element.closest(".hero__media").addClass("is-animated");
            }, 100);

            sessionStorage.setItem('seenHeroBalloonAnimation', 1);
        });
    });

    //Find Nav Images
    $(".nav .nav__content").each((index, element) => {
        let $this = $(element);
        let $img = $this.find("img");
        if ($img.length) {
            // $this.parent().addClass("hidden-xs hidden-sm");

            if ($this.parent().siblings().length == 1) {
                $this.parent().siblings().addClass("nav__only-text-col");
            }
        }
    });

    // Css Variables

    function updateVariables() {
        root.style.setProperty("--header-height", headerHeight + "px");
        root.style.setProperty("--header-bar-height", headerBarHeight + "px");
    }

    // Accordion

    $(".js-accordion .accordion__head button").on("click", function (e) {
        let $this = $(this);
        let $accordion_section = $this.closest(".accordion__section");
        let is_active = !$accordion_section.hasClass("is-active");

        if ($this.parents(".js-accordion-mobile").length && winWidth > 767) {
            return false;
        }

        // Close other accordions.
        $accordion_section
            .siblings()
            .removeClass("is-active")
            .find(".accordion__body")
            .stop()
            .slideUp();

        // Setting aria-expanded to false for other accordions.
        toggleAriaExpanded(
            $accordion_section.siblings().find(".accordion__head button"),
            false
        );

        // Expand/collapse this accordion.
        $accordion_section
            .toggleClass("is-active")
            .find(".accordion__body")
            .stop()
            .slideToggle();

        // Toggle aria-expanded between true/false to match current state.
        toggleAriaExpanded($this, is_active);
    });

    //Page Has Scroll Detector
    function pageScrollDetector() {
        let hasScroll = winScrollHeight > 50;
        $body.toggleClass("page-has-scroll", hasScroll);
    }

    // Scroll To
    $(".js-form-anchor").on("click", function (e) {
        e.preventDefault();
        const target = $(this).attr("href");
        $("html, body").animate(
            {
                scrollTop: $(target).offset().top,
            },
            1000
        );
    });


    $doc.on("click", ".js-scroll-to", function (e) {
        e.preventDefault();
        const target = $(this).attr("href").replace("#", "");
        console.log(target);

        if (target !== "") {
            let $target = $(
                'a[name="' +
                target +
                '"],[id="' +
                target +
                '"],[id="anchor--' +
                target +
                '"]'
            );

            if ($target.length) {
                $("html, body").animate(
                    {
                        scrollTop: $target.offset().top - headerHeight - 20,
                    },
                    1000
                );
            }
        }
    });

    $doc.find(".hero__actions a.btn").each(function () {
        var href = $(this).attr("href");

        if (href.includes("#")) {
            $(this).addClass("js-scroll-to");
        }
    });

    // Slider

    $(".js-slider .slider__slides").slick({
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        // autoplay: true,
        // autoplaySpeed: 2000,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    centerMode: true,
                    centerPadding: "15.2vw 0 0",
                },
            },
        ],
    });

    // Partner Carousel
    handleArticleFakeTile();
    $('.js-partner-slider').slick({
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        autoplay: true,
        autoplaySpeed: 2000,
        touchThreshold: 20,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    centerMode: true,
                },
            },
        ],
    });

    // Tiles Slider

    const initTilesSlider = () => {
        $('.slider--tiles').each(function () {
            let $this = $(this);

            $this.slick({
                infinite: false,
                slidesToShow: 4,
                slidesToScroll: 1,
                arrows: false,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 2.3,
                        },
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 1.35,
                        },
                    }
                ],
            });
        });
    }

    // Hero Slider 

    const initHeroSlider = () => {
        $('.slider--hero:not(.slider--hero--single)').each(function () {
            let $this = $(this);

            let autoPlaySpeed = 2000;

            if ($this.attr('data-speed') != undefined && $this.attr('data-speed').length) {
                autoPlaySpeed = parseInt($this.attr('data-speed')) * 1000;
            }

            let useArrows = true;
            let useDots = false;

            if ($this.attr('data-arrows') != undefined) {
                if ($this.attr('data-arrows') == 'false') {
                    useArrows = false;
                } else {
                    useArrows = true;
                }
            }

            if ($this.attr('data-dots') != undefined) {
                if ($this.attr('data-dots') == 'false') {
                    useDots = false;
                } else {
                    useDots = true;
                }
            }

            $this.slick({
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: true,
                autoplaySpeed: autoPlaySpeed,
                fade: true,
                cssEase: 'linear',
                pauseOnHover: false,
                pauseOnFocus: false,
                arrows: useArrows,
                dots: useDots
            });

            $this.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
                var $nextSlide = slick.$slides.eq(nextSlide);

                var mainBgColor = $nextSlide.css('--main-bg-color');
                var mainBgColor2 = $nextSlide.css('--main-bg-color-2');

                // Check if the color is "default" and unset the CSS variables
                if (mainBgColor === 'default') {
                    // Unset the CSS variables by setting them to 'initial'
                    $('.hero').css({
                        '--main-bg-color': '',
                        '--main-bg-color-2': ''
                    });
                } else {
                    // Apply the new CSS variables with a smooth transition
                    $('.hero').css({
                        '--main-bg-color': mainBgColor,
                        '--main-bg-color-2': mainBgColor2
                    });
                }

                // Force a reflow to trigger the transition
                void $('.hero')[0].offsetWidth;
            });
        });
    }
    function matchRowHeights() {
        // Get the current viewport width
        const viewportWidth = window.innerWidth;

        if (viewportWidth > 1365) {
            // Find the tallest .row element within .slider--hero .slides
            let maxHeight = 0;
            $('.slider--hero .slide .row').each(function () {
                const rowHeight = $(this).outerHeight();
                maxHeight = Math.max(maxHeight, rowHeight);
            });

            // Set the same height for all .row elements within .slider--hero .slides
            $('.slider--hero .slide .row').css('height', maxHeight + 'px');
        } else {
            // Clear the heights if viewport width is 1365px or below
            $('.slider--hero .slide .row').css('height', 'auto');
        }
    }

    // Call the function initially
    matchRowHeights();

    // Reevaluate the heights on window resize
    $(window).on('resize', function () {
        matchRowHeights();
    });



    const $eventsSlider = $(".js-slider-events:not(.slider--events-alt) .slider__slides");
    const $eventsSliderAlt = $(".js-slider-events.slider--events-alt .slider__slides");
    $eventsSlider.slick({
        infinite: false,
        slidesToShow: 3,
        slidesToScroll: 3,
        arrows: true,
        speed: 800,
        touchThreshold: 20,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    speed: 700,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    speed: 300,
                    centerMode: true,
                    centerPadding: "15.2vw 0 0",
                },
            },
        ],
    });

    $eventsSliderAlt.slick({
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 3,
        centerMode: false,
        arrows: true,
        speed: 800,
        touchThreshold: 20,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    speed: 700,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    speed: 300,
                    centerMode: true,
                },
            },
        ],
    });



    //  Implementing navigation of slides using mouse scroll
    // $eventsSlider.on('mousewheel', $.debounce( 18, function(e) {
    //     e.stopPropagation();
    //     e.preventDefault();

    //     var delta = Math.max(-1, Math.min(1, (e.originalEvent.wheelDelta || -e.originalEvent.detail)));
    //     if (delta < 0 ) {
    //         delta = 0
    //         $(this).slick('slickNext')
    //     } else{
    //         delta = 0
    //         $(this).slick('slickPrev')

    //     }
    // }));

    $(".js-slider-center .slider__slides").slick({
        infinite: true,
        slidesToShow: 4,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 2000,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2.5,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    centerMode: true,
                    centerPadding: "15.2vw 0",
                },
            },
        ],
    });

    $(".js-slider-gallery .slider__slides").slick({
        infinite: true,
        slidesToShow: 1,
        arrows: true,
    });

    $(".js-slider-autoplay .slider__slides").slick({
        infinite: true,
        slidesToShow: 1,
        arrows: true,
        autoplay: true,
        autoplaySpeed: 10000,
    });

    $(".js-slider-featured .slider__slides").slick({
        arrows: false,
        infinite: true,
        slidesToShow: 4,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 3,
                },
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    centerMode: true,
                    centerPadding: "15.2vw 0 0",
                },
            },
        ],
    });

    function facetEventListeners() {
        $(document).on("facetwp-loaded", function () {
            var $pager = $doc.find(".facetwp-facet-pager_ .facetwp-pager");
            if ($pager.html().length == 0) {
                console.log($pager.parent().parent());
                $pager.parent().parent().addClass("section__foot--hidden");
                $(".section-articles--archive").addClass(
                    "section-articles--archive--no-filters"
                );
            } else {
                $pager.parent().parent().removeClass("section__foot--hidden");
                $(".section-articles--archive").removeClass(
                    "section-articles--archive--no-filters"
                );
            }
            if (FWP.loaded) {
                $("html, body").animate(
                    {
                        scrollTop:
                            $(".facetwp-template").offset().top - headerHeight,
                    },
                    400
                );
            }
        });
    }

    function formStackFieldListeners() {
        $doc.on('click', '#field118674586', function (e) {
            // registration : initiate
            dataLayer.push({ "event": "registration-initiate" })
        })

        $doc.on('click', '#fsSubmitButton4629502', function () {
            dataLayer.push({ "event": "registration-submit" })
        })

        $doc.on('click', '#fsCell55875020', function () {
            dataLayer.push({ "event": "volunteer-initiate" })
        })

        $doc.on('click', "#fsSubmitButton2796640", function () {
            dataLayer.push({ "event": "volunteer-submit" })
        })
    }

    function maybe_scroll_to_anchor() {
        let offset = 50; // Offset the final position by 20px so it isn't right up against the bottom of the header.
        let hash = window.location.hash;

        if (hash !== "") {
            let id = hash.replace("#", "");
            let $target = $("#anchor--" + id);

            if ($target.length) {
                $("html, body").animate(
                    {
                        scrollTop: $target.offset().top - headerHeight - offset,
                    },
                    400
                );
            }
        }
    }

    function scrollToHashOnLoad() {
        let hash = window.location.hash;
        let headerHeight = $header.outerHeight();

        if (hash !== "") {
            let id = hash.replace("#", "");
            let $target = $('#' + id);

            // If no direct ID match, try with anchor-- prefix
            if (!$target.length) {
                $target = $("#anchor--" + id);
            }

            if ($target.length) {
                // Use setTimeout to ensure page is fully loaded and header height is calculated
                setTimeout(function () {
                    let offset = 20; // Small offset for better visual spacing
                    // console.log($target.offset().top - headerHeight - offset);
                    // console.log(headerHeight);
                    // console.log(offset);
                    // console.log($target.offset().top);
                    $("html, body").animate(
                        {
                            scrollTop: $target.offset().top - headerHeight - offset,
                        },
                        600 // Slightly slower animation for better UX
                    );
                }, 0);
            }
        }
    }

    // Add event listener for anchor links
    $doc.on('click', 'a[href^="#"]', function (e) {
        let href = $(this).attr('href');
        if (href !== "#") {  // Ignore empty anchors
            e.preventDefault();
            let id = href.replace("#", "");
            let $target = $("#anchor--" + id);

            if ($target.length) {
                $("html, body").animate(
                    {
                        scrollTop: $target.offset().top - headerHeight - 50,
                    },
                    400
                );
                // Update URL hash without triggering scroll
                history.pushState(null, null, href);
            }
        }
    });

    function initMatchHeights() {
        $(
            ".section-articles .section__content .article__content"
        ).matchHeight();
    }

    // Helper function to set a cookie
    function setCookie(name, value, hours) {
        const date = new Date();
        date.setTime(date.getTime() + (hours * 60 * 60 * 1000));
        document.cookie = `${name}=${value}; expires=${date.toUTCString()}; path=/`;
    }

    // Helper function to get a cookie
    function getCookie(name) {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(';').shift();
        return null;
    }

    function initPopups() {
        // Handle family-registration popup

        // Check if the current page is the homepage
        let isHomepage = window.location.pathname === '/' || window.location.pathname === '';

        // If ?show-popup is set in the URL, show the popup
        let forceShow = window.location.search.includes('show-popup');

        // Show the popup only if on the homepage and cookie is not set or if forced to show
        if (isHomepage && (!getCookie('seenFamilyRegistrationPopup') || forceShow)) {
            setTimeout(function () {
                $(".section--popup[data-popup='family-registration']").fadeIn();
            }, 28000);

            // Set a cookie with 1-hour expiry
            setCookie('seenFamilyRegistrationPopup', 1, 1);
        }

        // Handle select-language popup
        let showLangPopup = window.location.search.includes('language-request');

        if (showLangPopup) {
            $(".section--popup[data-popup='select-language']").fadeIn();
        }
    }


    function handleArticleFakeTile() {
        if ($win.width() < 768) {
            let $fakeTile = $('.article--fake');

            if ($fakeTile.length) {
                // Remove fake tile.
                $fakeTile.remove();
            }
        }
    }


    updateVariables();
    facetEventListeners();
    efront_donate_form();

    $(window).on('load', function () {
        initDonationFormGTMNew();
    });

    // Re-initialize donation form when Gravity Forms renders
    $(document).on('gform_post_render', function () {
        efront_donate_form();
        scrollToHashOnLoad();
    });

    // Re-initialize donation form when page content changes (for AJAX navigation, etc.)
    $(document).on('DOMNodeInserted', '.gform_wrapper', function () {
        // efront_donate_form();
    });

    // Re-initialize donation form when forms are loaded via AJAX
    $(document).on('gform_loaded', function () {
        // efront_donate_form();
    });

    $win.on("load", function () {
        winScrollHeight = $win.scrollTop();
        winWidth = $win.outerWidth();
        winHeight = $win.outerHeight();
        headerHeight = $header.outerHeight();
        headerBarHeight = $headerBar.outerHeight();

        scrollToHashOnLoad();

        AOS.init();
        initCounters();
        maybe_scroll_to_anchor();
        loadVideoThumbnailImages();
        resetFormStackFormTabIndex();
        formStackScrollToUpdate();
        checkCounters();
        pageScrollDetector();
        animateOnScroll();
        formStackFieldListeners();
        initPopups();
        updateVariables();
        initMatchHeights();
        initHeroSlider();
        initTilesSlider();
    });


    window.addEventListener(
        "resize",
        function () {
            winWidth = $win.outerWidth();
            winHeight = $win.outerHeight();
            headerHeight = $header.outerHeight();
            headerBarHeight = $headerBar.outerHeight();
            updateVariables();
            initMatchHeights();
        },
        { passive: true }
    );

    window.addEventListener(
        "scroll",
        function () {
            winScrollHeight = $win.scrollTop();

            checkCounters();
            pageScrollDetector();
            animateOnScroll();
        },
        { passive: true }
    );

    /**
     * Accessibility enhancements.
     */

    /**
     * Set tabindex to -1 for these elements to prevent access via keyboard navigation until they are revealed.
     */
    $(".js-tabindex-neg").attr("tabindex", -1);

    /**
     * Toggling main nav menu aria-expanded & dropdown tabindex on hover & focus.
     */
    $(".nav > ul > li").on(
        "mouseenter mouseleave focusin focusout",
        function (e) {
            let event_type = e.type,
                $this = $(this),
                $trigger_el = $this.find("> a"),
                $target_el = $this.find("> .nav__dd"),
                current_state =
                    $trigger_el.attr("aria-expanded") === "true" ? true : false,
                new_state = false; // Default.

            if (event_type === "mouseenter" || event_type === "focusin") {
                new_state = true;
            } else if (
                event_type === "mouseleave" ||
                event_type === "focusout"
            ) {
                new_state = false;
            }

            if (current_state !== new_state) {
                $trigger_el.attr("aria-expanded", new_state ? "true" : "false");

                toggleTabIndex($target_el, new_state);
            }
        }
    );

    /**
     * Converts text to voice using the Web Speech API
     * @param {string} text - The text to be converted to speech
     * @returns {undefined}
     */
    function textToVoice(text) {
        if ('speechSynthesis' in window) {
            const synth = window.speechSynthesis;
            const utterance = new SpeechSynthesisUtterance(text);
            synth.speak(utterance);
        } else {
            alert('Sorry, your browser does not support text-to-speech.');
        }
    }

    /**
     * Toggle or set aria-expanded attr. If the attr is not present (and no state is passed) it'll be set to true.
     *
     * @param {jQuery|Element} element The jQuery object or vanilla Element.
     * @param {bool}           state   (Optional) The state the attr should be set to. Do not pass this to toggle the attr.
     */
    function toggleAriaExpanded(element, state) {
        var $element = $(element);

        if ($element.length) {
            if (state === undefined) {
                $element.attr("aria-expanded", function (i, attr) {
                    return !(attr === "true");
                });
            } else {
                $element.attr("aria-expanded", state ? "true" : "false");
            }
        }
    }

    function toggleTabIndex(element, visible) {
        var $element = $(element);

        if ($element.length) {
            if (visible) {
                $element.removeAttr("tabindex");
            } else {
                $element.attr("tabindex", "-1");
            }
        }
    }


    function loadVideoThumbnailImages() {
        $(".js-get-thumbnail").each(function () {
            var $this = $(this);

            var $type = $this.attr("data-type");
            var $id = $this.attr("data-id");

            console.log($type, $id);

            if ($type == "vimeo") {
                $.ajax({
                    type: "GET",
                    url: "http://vimeo.com/api/v2/video/" + $id + ".json",
                    jsonp: "callback",
                    dataType: "json",
                    success: function (data) {
                        var thumbnail_src = data[0].thumbnail_large;
                        console.log(thumbnail_src);
                        $this.prepend(
                            '<img src="' + thumbnail_src + '" alt="image"/>'
                        );
                    },
                });
            } else {
                console.log("here");
                $this.prepend(
                    '<img src=" https://img.youtube.com/vi/' +
                    $id +
                    '/0.jpg" alt="image"/>'
                );
            }
        });
    }

    function formStackScrollToUpdate() {
        $doc.on("click", "#fsSubmitButton4849396", function () {
            var $this = $(this);
            $("html, body").animate(
                {
                    scrollTop: $("#fsForm4849396").offset().top - 350,
                },
                1000
            );
        });
    }

    function resetFormStackFormTabIndex() {
        $doc.find(".fsField").each(function (index, element) {
            console.log($(this).attr("tabindex", index + 1));
        });
    }

    $doc.on("gform_confirmation_loaded", function (event, formId) {
        setTimeout(function () {
            console.log($doc.find(".gform_confirmation_message").offset().top);
            $("html, body").animate(
                {
                    scrollTop:
                        $doc.find(".gform_confirmation_message").offset().top -
                        500,
                },
                1000
            );
        }, 100);
    });

    /**
     * Donation Form GTM Events
     */
    function initDonationFormGTM() {
        console.log("Initiallizing Donation Form GTM");


        // Events
        // donation-one-off-add-payment
        // donation-regular-add-payment

        $doc.on(
            "change",
            "#input_1_1 input.gfield-choice-input, #input_1_31 input.gfield-choice-input",
            function () {
                var $this = $(this);
                var val = $this.val();
                // current donation type
                var type = $("#input_1_5 input[type='radio']:checked").val();

                if (val !== "gf_other_choice") {
                    dataLayer.push({
                        event:
                            type == "monthly"
                                ? "donation-regular-add-payment"
                                : "donation-one-off-add-payment",
                    });
                }
            }
        );

        $doc.on("blur", "#input_1_1_other", function () {
            var $this = $(this);
            var val = $(this).val();
            // current donation type
            var type = $("#input_1_5 input[type='radio']:checked").val();

            if (val.length) {
                dataLayer.push({
                    event:
                        type == "monthly"
                            ? "donation-regular-add-payment"
                            : "donation-one-off-add-payment",
                });
            }
        });

        // donation-complete-one-off
        // donation-complete-regular

        // ADDED IN NEW GTM FUNCTION BELOW !!!

        /*if ($("body").data("donation") !== undefined && $("body").data("donation").length) {
            var donation_complete_data = $("body").data("donation").split("|");
            if (donation_complete_data.length == 3) {
                var method = donation_complete_data[0];
                var amount = donation_complete_data[1];
                var transId = donation_complete_data[2];

                dataLayer.push({
                    event:
                        method == "one off"
                            ? "donation-complete-one-off"
                            : "donation-complete-regular",
                    donationType: method,
                    donationValue: parseFloat(amount),
                    donationId: transId,
                });
            }
        }*/
    }

    /**
     * Initialize Lottie animations
     * Ensures animation always autoplays, even if previously initialized.
     */
    function initHeartsLottieAnimation() {
        $('.js-lottie-animation').each(function () {
            var $this = $(this);
            var animationSrc = $this.data('src');

            if (animationSrc && typeof lottie !== 'undefined') {
                // If already initialized, destroy and re-initialize to ensure autoplay
                if ($this.data('lottie-animation')) {
                    var existingAnimation = $this.data('lottie-animation');
                    try {
                        existingAnimation.destroy && existingAnimation.destroy();
                    } catch (e) { }
                    $this.removeData('lottie-animation');
                }
                // Initialize new animation and store the instance
                var animation = lottie.loadAnimation({
                    container: this,
                    renderer: 'svg',
                    loop: false,
                    autoplay: true,
                    path: animationSrc
                });
                // Store the animation instance for future use
                $this.data('lottie-animation', animation);
            }
        });
    }

    /**
     * Donation Form GTM Events (NEW)
     */

    function initDonationFormGTMNew() {

        // Helper function to push tracking events to both GTM dataLayer and Meta Pixel
        function pushTracking(data) {
            console.log('[pushTracking]', data.event, data);

            // Push to Google Tag Manager dataLayer
            if (typeof dataLayer !== 'undefined') {
                console.log('[pushTracking] dataLayer', data);
                dataLayer.push(data);
            }

            // Push to Meta Pixel using trackCustom
            if (typeof fbq !== 'undefined' && data.event) {
                console.log('[pushTracking] fbq', data);
                var { event, ...fbqData } = data;
                fbq('trackCustom', event, fbqData);
            }
        }

        // Page Changed on Donation Form
        // Event Name = dfStepView
        $(document).on('gform_post_render', function (event, form_id, current_page) {
            if (form_id == 25) { // New Donation Form ID
                pushTracking({
                    event: "dfStepView",
                    form_id: form_id,
                    donation_type: typeof window.donationType !== 'undefined' ? window.donationType : "single",
                    step_number: current_page
                });

                if (current_page == 2) {
                    // Donation Type Selected:
                    // Event Name = dfDonationTypeSelected

                    pushTracking({
                        event: "dfDonationTypeSelected",
                        donation_type: typeof window.donationType !== 'undefined' ? window.donationType : "single"
                    });
                }
            }
        });

        // Pagination Clicked
        // Event Name = dfStepNav
        $(document).on("click", ".gform_next_button", function () {
            if ($(document).find('#gform_wrapper_25').length) {
                pushTracking({
                    event: "dfStepNav",
                    form_id: 25,
                    direction: "next",
                    step_number: $('.gf_page_steps').children().index($('.gf_step_active')) + 1
                });
            }
        })

        $(document).on("click", ".gform_previous_button", function () {
            if ($(document).find('#gform_wrapper_25').length) {
                pushTracking({
                    event: "dfStepNav",
                    form_id: 25,
                    direction: "previous",
                    step_number: $('.gf_page_steps').children().index($('.gf_step_active')) + 1
                });
            }
        })

        // Confirmation Page
        // Event Name = dfConfirmationView
        if (
            typeof window.dataDonation !== 'undefined' &&
            window.dataDonation.formId &&
            window.dataDonation.donationType &&
            window.dataDonation.donationValue &&
            window.dataDonation.donationId &&
            window.dataDonation.currency &&
            window.dataDonation.paymentMethod
        ) {
            pushTracking({
                event: "dfConfirmationView",
                form_id: window.dataDonation.formId,
                donation_type: window.dataDonation.donationType,
                donation_amount: parseFloat(window.dataDonation.donationValue),
                donation_id: window.dataDonation.donationId,
                currency: window.dataDonation.currency,
                payment_method: window.dataDonation.paymentMethod
            });

            // Meta Pixel Purchase event for conversion tracking
            if (typeof fbq !== 'undefined') {
                fbq('track', 'Purchase', {
                    value: parseFloat(window.dataDonation.donationValue),
                    currency: window.dataDonation.currency,
                    content_type: 'donation',
                    content_name: window.dataDonation.donationType,
                    order_id: window.dataDonation.donationId
                });

                // Send donation type specific event
                var donationEventData = {
                    value: parseFloat(window.dataDonation.donationValue),
                    currency: window.dataDonation.currency,
                    order_id: window.dataDonation.donationId
                };

                if (window.dataDonation.donationType === 'single') {
                    console.log('DonationSingle', donationEventData);
                    fbq('trackCustom', 'DonationSingle', donationEventData);
                } else if (window.dataDonation.donationType === 'regular') {
                    console.log('DonationRegular', donationEventData);
                    fbq('trackCustom', 'DonationRegular', donationEventData);
                }
            }
        }
    }

    // New Menu JavaScript functions

    function setLongestSubMenuHeight() {
        /*$('.level-0').each(function() {
            let maxHeight = 0;
            $(this).find('.nav__content').each(function() {
                const height = $(this).outerHeight();
                maxHeight = Math.max(maxHeight, height);
            });
            $(this).css('--submenu-height', maxHeight + 'px');
        });*/

        $('.level-0').each(function () {
            let $this = $(this);
            let maxHeight = $this.find('.level-1.active').find('.nav__content').outerHeight();
            $this.css('--submenu-height', maxHeight + 'px');
        })
    }

    $(window).on('load', function () {
        setInterval(setLongestSubMenuHeight, 500);
    });

    function calculateNavContentWidth() {
        // Calculate the width of the nav__content by getting the width of the .nav__dd and minusing the .nav__dd > .submenu width
        const $nav = $('.nav__dd').eq(0);

        if ($nav.length) {
            const $submenu = $nav.find('.sub-menu');
            const submenuWidth = $submenu.outerWidth();
            const navContentWidth = $nav.outerWidth() - submenuWidth;

            // Set the CSS variable
            document.documentElement.style.setProperty('--nav-content-width', navContentWidth + 'px');
        }
    }

    $(window).on('load', function () {
        setInterval(calculateNavContentWidth, 500);
    });

    // Handler data-image-url hover/focus state
    $doc.on('mouseenter', '[data-image-url]', function () {
        let $this = $(this);
        let imageUrl = $this.data('image-url');
        let $parentNavItem = $this.closest('.level-0');

        if (imageUrl) {
            // Update image src of.nav__content-image to the new src
            $parentNavItem.find('.nav__content-image')
                .attr('src', imageUrl)
                .addClass('active');
        } else {
            $parentNavItem.find('.nav__content-image')
                .removeClass('active');
        }
    });

    // Ensure 'other' price fields are numeric and capped at 990000, supporting decimals.
    function enforceOtherPriceFieldLimits() {
        // Listen for input/change on all .gchoice--other fields
        $doc.on('change', '.amount--monthly .gchoice--other, .amount--one-off .gchoice--other', function () {
            let val = $(this).val();
            // Remove all except digits and dot
            val = val.replace(/[^\d.]/g, '');
            // Only allow one dot
            let dotIndex = val.indexOf('.');
            if (dotIndex !== -1) {
                // Remove any additional dots
                val = val.substring(0, dotIndex + 1) + val.substring(dotIndex + 1).replace(/\./g, '');
            }
            // Limit to two decimal places if present
            if (val.indexOf('.') !== -1) {
                let [intPart, decPart] = val.split('.');
                decPart = decPart.substring(0, 2);
                val = intPart + '.' + decPart;
            }
            // Convert to float and validate
            let num = parseFloat(val);
            if (isNaN(num)) num = '';
            if (num < 1) num = 1;
            if (num > 990000) num = 990000;
            // Set value with max two decimals
            if (num !== '') {
                // Show as-is without formatting to allow decimals
                $(this).val(num);
            } else {
                $(this).val('');
            }
        });
    }

    function initNavItemMouseEnterListener() {
        let $navItems = $('.level-0');
        let $childrenNavItems = $('.level-1');

        // Original mouseenter functionality - keep as is
        $navItems.on('mouseenter', function () {
            // set the first .level-1 item to be active and remove it from all other items within the same parent.level-0
            $(this).find('.level-1').first().addClass('active').siblings().removeClass('active');
            //setLongestSubMenuHeight();
        });

        $navItems.on('mouseleave', function () {
            setTimeout(function () { $('.nav__dd').removeClass("parent-has-no-items"); }, 400);
        })

        $childrenNavItems.on('mouseenter', function () {
            // Add active class to this current item and remove it from all other items within the same parent .level-0
            $(this).addClass('active').siblings().removeClass('active');

            if (!$(this).hasClass('menu-item-has-children')) {
                // .nav-item-mega-menu
                let $parentDDMenu = $(this).parents('.nav__dd').eq(0);
                let $parentMenuItem = $parentDDMenu.parents('.nav-item-mega-menu').eq(0)

                if ($parentMenuItem.length > 0) {
                    $parentDDMenu.addClass("parent-has-no-items");
                }

            } else {
                $('.nav__dd').removeClass("parent-has-no-items");
            }

            setLongestSubMenuHeight();
        });

        // Add separate focus listener for .level-0 elements
        $navItems.find('a').on('focus', function () {
            const $parentNavItem = $(this).closest('.level-0');

            // Toggle active class on the first .level-1 item when its parent .level-0 link is focused
            $parentNavItem.find('.level-1').first().addClass('active').siblings().removeClass('active');
            //setLongestSubMenuHeight();
        });

        $childrenNavItems.find('a').on('focus', function () {
            const $parentNavItem = $(this).closest('.level-0');
            const $activeItem = $(this).closest('.level-1');

            // Toggle active class on the current item when its parent.level-0 link is focused
            $activeItem.addClass('active').siblings().removeClass('active');
        })
    }
    initNavItemMouseEnterListener();

    function initNavigationNavContentImages() {
        let $navItems = $('.level-0');

        $navItems.each(function () {
            // Find first [data-image-url] value of .active item
            let $activeItem = $(this).find('.active');
            let imageUrl = $activeItem.find('[data-image-url]').data('image-url');

            if (imageUrl) {
                // Update image src of.nav__content-image to the new src
                $(this).find('.nav__content-image')
                    .attr('src', imageUrl)
                    .addClass('active');
            } else {
                $(this).find('.nav__content-image')
                    .removeClass('active');
            }
        })
    }
    initNavigationNavContentImages();

    /**
     * Donation form.
     */
    function efront_donate_form() {
        $(".js-switch-to-monthly").on("click", function (e) {
            e.preventDefault();

            let $duration_input = $(
                ".target--duration input[value='Monthly' i]"
            );

            if ($duration_input.length) {
                $("html, body").animate(
                    {
                        scrollTop: $duration_input.offset().top - 50,
                    },
                    400,
                    function () {
                        $duration_input.prop("checked", true).trigger("change");
                    }
                );
            }
        });

        $doc.on("click", ".donation-amount-btn, .donation--popup__close", function (e) {
            e.preventDefault();

            let $this = $(this);
            let donationAmount = $this.data('donation-amount');
            let $donationTypeInput = $('.target--duration input[value="Monthly" i]');
            let $nextButton = $('.gform_next_button');

            if (typeof donationAmount == 'undefined' || donationAmount == null) {
                $('.donation--popup').removeClass('is-open');
                $('body').removeClass('no-scroll');
                // Click the nextButton
                $nextButton.click();
                return;
            }

            $donationTypeInput.prop('checked', true).trigger('change');

            // Try and find .amount--monthly input with same value as $donationAmount
            let $donationAmountInput = $('.amount--monthly input').filter(function () {
                return $(this).val() == donationAmount;
            });

            if ($donationAmountInput.length) {
                $donationAmountInput.prop('checked', true).trigger('change');
            } else {
                // If not found, select the "gf_other_choice" input and populate the .gchoice--other input
                let $otherChoiceInput = $('.amount--monthly input[value="gf_other_choice"]');
                if ($otherChoiceInput.length) {
                    $otherChoiceInput.prop('checked', true).trigger('change');
                    // Find the .gchoice--other input within the same parent as the "gf_other_choice" input
                    let $otherInput = $otherChoiceInput.parent().find('.gchoice--other');
                    if ($otherInput.length) {
                        $otherInput.val(donationAmount).trigger('input').trigger('change');
                    }
                }
            }

            // Scroll to top of .target--duration container
            var $targetDuration = $('.target--duration');
            if ($targetDuration.length) {
                $('html, body').animate({
                    scrollTop: $targetDuration.offset().top - 50
                }, 400);
            }

            $('.donation--popup').removeClass('is-open');
            $('body').removeClass('no-scroll');
            // Click the nextButton
            $nextButton.click();
        });

        // Init Donation Amonut Message
        let $donationTypeInputs = $('.target--duration input');
        let $donationOneOffInputs = $('.amount--one-off input');
        let $donationMonthyInputs = $('.amount--monthly input');
        let $donationMessageItems = $('.donation-message');

        function handleHeartAnimation(force = true) {
            let type = $donationTypeInputs.filter(':checked').val();
            var isInputVisible = $donationTypeInputs.is(':visible');

            if (type == "monthly" && (isInputVisible || force)) {
                initHeartsLottieAnimation();
            }
        }

        function changeDonationMessage() {
            let type = $donationTypeInputs.filter(':checked').val();
            var oneOff = $donationOneOffInputs.filter(':checked').val();
            var monthly = $donationMonthyInputs.filter(':checked').val();

            if (oneOff == "gf_other_choice") {
                // Find .gchoice--other number input which within the same parent as .amount--one-off
                var $otherInput = $donationOneOffInputs.filter(':checked').parent().find('.gchoice--other');
                oneOff = $otherInput.val();
            }

            if (monthly == "gf_other_choice") {
                // Find .gchoice--other number input which within the same parent as .amount--monthly
                var $otherInput = $donationMonthyInputs.filter(':checked').parent().find('.gchoice--other');
                monthly = $otherInput.val();
            }

            // Remove active class from all
            $donationMessageItems.removeClass('active');

            if (type == "monthly") {
                // For monthly donations, show only monthly-specific boxes or 'all' type boxes
                let monthlyAmount = monthly ? monthly.replace('$', '') : '';
                let $monthlyMessageItem = $donationMessageItems.filter(function () {
                    let $item = $(this);
                    let itemType = $item.data('type');
                    let itemAmount = $item.data('donation-amount');

                    // Show monthly-specific boxes or 'all' type boxes that match the amount
                    return (itemType === 'monthly' || itemType === 'all') && itemAmount == monthlyAmount;
                });

                window.donationType = "regular";

                // Add active class to $monthlyMessageItem and remove it from all other items within the same parent .level-0
                $monthlyMessageItem.addClass('active').siblings().removeClass('active');
            } else {
                // For one-off donations, show only one-off-specific boxes or 'all' type boxes
                let oneOffAmount = oneOff ? oneOff.replace('$', '') : '';
                let $oneOffMessageItem = $donationMessageItems.filter(function () {
                    let $item = $(this);
                    let itemType = $item.data('type');
                    let itemAmount = $item.data('donation-amount');

                    // Show one-off-specific boxes or 'all' type boxes that match the amount
                    return (itemType === 'one-off' || itemType === 'all') && itemAmount == oneOffAmount;
                });

                window.donationType = "single";

                // Add active class to $oneOffMessageItem and remove it from all other items within the same parent .level-0
                $oneOffMessageItem.addClass('active').siblings().removeClass('active');
            }
        }

        // Cache for donation fee responses to avoid repeated AJAX requests
        var donationFeeCache = {};

        function updateDonationFeeAmount() {
            // Get the current donation value
            let type = $donationTypeInputs.filter(':checked').val();
            var oneOff = $donationOneOffInputs.filter(':checked').val();
            var monthly = $donationMonthyInputs.filter(':checked').val();

            // Get the current donation amount
            let donationAmount = 0;
            if (type == "monthly") {
                if (monthly == "gf_other_choice") {
                    // Find .gchoice--other number input which within the same parent as .amount--monthly
                    var $otherInput = $donationMonthyInputs.filter(':checked').parent().find('.gchoice--other');
                    donationAmount = $otherInput.val();
                } else {
                    donationAmount = monthly ? monthly.replace('$', '') : '';
                }
            } else {
                if (oneOff == "gf_other_choice") {
                    // Find .gchoice--other number input which within the same parent as .amount--one-off
                    var $otherInput = $donationOneOffInputs.filter(':checked').parent().find('.gchoice--other');
                    donationAmount = $otherInput.val();
                } else {
                    donationAmount = oneOff ? oneOff.replace('$', '') : '';
                }
            }

            // Helper function to apply the fee response
            function applyFeeResponse(response) {
                // Check if input is checked
                if ($('.fee-cover-field input').is(':checked')) {
                    $('.fee-amount-field').find('input').val(response.feeAmount);
                } else {
                    $('.fee-amount-field').find('input').val('0');
                }

                $('.fee-amount-field').find('input').trigger('change');

                // Update #payment-fees field with fee amount
                $('#payment-fees').html(`$${parseFloat(response.feeAmount).toFixed(2)}`)
            }

            // Check if we have a cached response for this donation amount
            var cacheKey = String(donationAmount);
            if (donationFeeCache.hasOwnProperty(cacheKey)) {
                applyFeeResponse(donationFeeCache[cacheKey]);
                return;
            }

            $.ajax({
                url: main_theme.ajax_url,
                type: 'GET',
                dataType: 'json',
                data: {
                    action: 'fetch_donation_fee_price',
                    donationAmount: donationAmount
                },
                success: function (response) {
                    // Cache the response for this donation amount
                    donationFeeCache[cacheKey] = response;

                    applyFeeResponse(response);
                },
                error: function (e) {
                    // console.log("Error fetching fee amount:", e);
                }
            });
        }

        function updateDonationUpsellSections() {
            // Get the current donation value
            let type = $donationTypeInputs.filter(':checked').val();
            var oneOff = $donationOneOffInputs.filter(':checked').val();
            var monthly = $donationMonthyInputs.filter(':checked').val();

            let $nextButton = $('.gform_next_button');

            // Get the current donation amount
            let donationAmount = 0;
            if (type == "monthly") {
                if (monthly == "gf_other_choice") {
                    // Find .gchoice--other number input which within the same parent as .amount--monthly
                    var $otherInput = $donationMonthyInputs.filter(':checked').parent().find('.gchoice--other');
                    donationAmount = $otherInput.val();
                } else {
                    donationAmount = monthly ? monthly.replace('$', '') : '';
                }

                // Check if (window.nextButtonOnClickEvent is set)
                if (typeof window.hasSuggestedRegularDonation == 'undefined' || !window.hasSuggestedRegularDonation) {
                    if (window.nextButtonOnClickEvent) {
                        $nextButton.attr('onclick', window.nextButtonOnClickEvent);
                    }
                }

            } else {
                if (oneOff == "gf_other_choice") {
                    // Find .gchoice--other number input which within the same parent as .amount--one-off
                    var $otherInput = $donationOneOffInputs.filter(':checked').parent().find('.gchoice--other');
                    donationAmount = $otherInput.val();
                } else {
                    donationAmount = oneOff ? oneOff.replace('$', '') : '';
                }

                // Check if (window.nextButtonOnClickEvent is set)
                if (typeof window.hasSuggestedRegularDonation == 'undefined' || !window.hasSuggestedRegularDonation) {
                    if (window.nextButtonOnClickEvent) {
                        $nextButton.attr('onclick', "");
                    }
                }
            }

            // alert(donationAmount);

            // Update .donation-upsel-current-donation field with donation amount formatted to 2 decimal places
            $('.donation-upsel-current-donation').each(function () {
                $(this).html('$' + parseFloat(donationAmount).toFixed(2));
            });

            donationAmount = parseFloat(donationAmount);
            let $donationUpsellGroups = $('.donation-upsell-group');
            let foundActive = false;
            $donationUpsellGroups.each(function () {
                let $group = $(this);
                let min = parseFloat($group.data('min'));
                let max = $group.data('max');
                max = (max === '' || max === undefined || max === null) ? Infinity : parseFloat(max);
                if (!isNaN(donationAmount) && donationAmount >= min && donationAmount <= max) {
                    $group.addClass('is-active');
                    foundActive = true;
                } else {
                    $group.removeClass('is-active');
                }
            });

            if (!foundActive && $donationUpsellGroups.length > 0) {
                $donationUpsellGroups.removeClass('is-active');
                $donationUpsellGroups.first().addClass('is-active');
            }

            // Update #donation-promo-amount field if it exists with 2x the donation amount, formatted with commas
            donationAmount = Number(donationAmount);
            if ($('#donation-promo-amount').length && !isNaN(donationAmount) && donationAmount > 0) {
                let doubled = donationAmount * 2;
                let commified = doubled.toLocaleString('en-US', { maximumFractionDigits: 0 });
                $('#donation-promo-amount').html(`$${commified}`);
            }

        }

        function initDonationUpsellPopup() {
            // Only run if donation type is monthly and we haven't suggested regular donation yet
            let type = $donationTypeInputs.filter(':checked').val();

            if (type == "one off" && (typeof window.hasSuggestedRegularDonation == 'undefined' || !window.hasSuggestedRegularDonation) && window.currentPage == 1) {
                let $nextButton = $('.gform_next_button');
                // Remove onclick event from next button

                if ($nextButton.attr('onclick')) {
                    window.nextButtonOnClickEvent = $nextButton.attr('onclick');
                    $nextButton.attr('onclick', '');
                }

                // Add listener to the gform next button to cancel the submit and open the popup instead

                $nextButton.on('click', function (e) {
                    if ((typeof window.hasSuggestedRegularDonation == 'undefined' || !window.hasSuggestedRegularDonation) && $(this).attr('onclick') == "" && window.currentPage == 1) {
                        e.preventDefault();
                        $('.donation--popup').addClass('is-open');
                        $('body').addClass('no-scroll');

                        // Re apply on click function
                        $nextButton.attr('onclick', window.nextButtonOnClickEvent);
                        window.hasSuggestedRegularDonation = true;
                    }
                });
            }
        }

        async function initGooglePlacesAutoComplete() {
            try {
                // Load the Places library
                const { Autocomplete } = await google.maps.importLibrary("places");

                // Get the input element using jQuery
                const $input = $('.donation-address-field .address_line_1 input');

                // Check if element exists
                if ($input.length === 0) {
                    console.error('Address input field not found');
                    return;
                }

                // Get target field elements
                const $cityInput = $('.donation-address-field .address_city input');
                const $stateInput = $('.donation-address-field .address_state input');
                const $zipInput = $('.donation-address-field .address_zip input');
                const $addressLine2 = $('.donation-address-field .address_line_2');
                const $addressCountry = $('.donation-address-field .address_country');

                // Hide fields initially using sr-only class
                $('.donation-address-field .address_city').addClass('sr-only');
                $('.donation-address-field .address_state').addClass('sr-only');
                $('.donation-address-field .address_zip').addClass('sr-only');
                $addressCountry.addClass('sr-only');
                $addressLine2.addClass('sr-only');

                // Function to show other fields
                function showOtherFields() {
                    $('.donation-address-field .address_city').removeClass('sr-only');
                    $('.donation-address-field .address_state').removeClass('sr-only');
                    $('.donation-address-field .address_zip').removeClass('sr-only');
                    $addressLine2.removeClass('sr-only');
                    $addressCountry.removeClass('sr-only');
                }

                // Check if field has value and show other fields
                function checkAndShowFields() {
                    const currentValue = $input.val().trim();
                    if (currentValue.length > 0) {
                        showOtherFields();
                    }
                }

                // Show fields when input gains focus and has a value
                $input.on('focus', function () {
                    checkAndShowFields();
                });

                // Show fields when user types/inputs data
                $input.on('input keyup paste', function () {
                    // Small delay to ensure value is updated
                    setTimeout(() => {
                        checkAndShowFields();
                    }, 100);
                });

                // Check on page load in case field already has a value
                setTimeout(() => {
                    checkAndShowFields();
                }, 500);

                // Create autocomplete instance (Google API expects DOM element, not jQuery object)
                autocomplete = new Autocomplete($input[0], {
                    // Restrict to addresses only
                    types: ['address'],

                    // Restrict to Australia
                    componentRestrictions: { country: 'AU' },

                    // Specify what data to return
                    fields: [
                        'place_id',
                        'formatted_address',
                        'name',
                        'geometry.location',
                        'address_components',
                        'types'
                    ]
                });

                // Add listener for when a place is selected
                autocomplete.addListener('place_changed', () => {
                    const place = autocomplete.getPlace();

                    // Console log the selected place data
                    console.log('Selected place:', place);
                    console.log('Address:', place.formatted_address);
                    console.log('Coordinates:', place.geometry?.location?.lat(), place.geometry?.location?.lng());
                    console.log('Place ID:', place.place_id);

                    // Clear existing values
                    $cityInput.val('');
                    $stateInput.val('');
                    $zipInput.val('');
                    $addressLine2.find('input').val('');

                    // Parse address components and populate fields
                    if (place.address_components) {
                        place.address_components.forEach(component => {
                            const types = component.types;
                            const longName = component.long_name;
                            const shortName = component.short_name;

                            // Map Australian address components to fields
                            if (types.includes('locality')) {
                                // City/Suburb
                                $cityInput.val(longName);
                            } else if (types.includes('administrative_area_level_1')) {
                                // State
                                $stateInput.val(shortName); // e.g., "NSW", "VIC", "QLD"
                            } else if (types.includes('postal_code')) {
                                // Postal code
                                $zipInput.val(longName);
                            } else if (types.includes('sublocality_level_1') && $cityInput.val() === '') {
                                // Use sublocality if no locality found
                                $cityInput.val(longName);
                            } else if (types.includes('subpremise')) {
                                // Apartment, unit, suite number, etc.
                                // Capitalize first letter if possible
                                const ucfirstLongName = longName.charAt(0).toUpperCase() + longName.slice(1);
                                $addressLine2.find('input').val(ucfirstLongName);
                            }
                        });
                    }

                    // Update the main address input with street address only (not full formatted address)
                    let streetAddress = '';
                    if (place.address_components) {
                        const streetNumber = place.address_components.find(c => c.types.includes('street_number'))?.long_name || '';
                        const route = place.address_components.find(c => c.types.includes('route'))?.long_name || '';
                        streetAddress = `${streetNumber} ${route}`.trim();
                    }

                    // Use street address if available, otherwise use formatted address
                    $input.val(streetAddress || place.formatted_address);

                    // Show all fields since we have an address
                    showOtherFields();

                    console.log('Fields populated:', {
                        city: $cityInput.val(),
                        state: $stateInput.val(),
                        zip: $zipInput.val(),
                        addressLine2: $addressLine2.find('input').val()
                    });
                });

                console.log('Google Places Autocomplete initialized successfully');

            } catch (error) {
                console.error('Error loading Google Places:', error);
            }
        }

        $donationTypeInputs.on('change', function () {
            handleHeartAnimation();
            changeDonationMessage();
            updateDonationFeeAmount();
            updateDonationUpsellSections();
        });

        $donationOneOffInputs.on('change input', function () {
            changeDonationMessage();
            updateDonationFeeAmount();
            updateDonationUpsellSections();
        });

        $donationMonthyInputs.on('change', function () {
            changeDonationMessage();
            updateDonationFeeAmount();
            updateDonationUpsellSections();
        });

        changeDonationMessage();
        updateDonationFeeAmount();
        updateDonationUpsellSections();
        enforceOtherPriceFieldLimits()

        $(document).on('gform_post_render', function (event, form_id, current_page) {
            if (form_id == 25) {
                window.currentPage = current_page;
                if (current_page == 1) {
                    handleHeartAnimation(true);
                    initDonationUpsellPopup();
                }

                if (current_page == 2) {
                    initGooglePlacesAutoComplete();
                }
            }
        })

        $('.fee-amount-field').find('input').on('change', function () {
            // Make sure it's always absolute number
            let feeAmount = $(this).val();
            feeAmount = Math.abs(feeAmount);
            $(this).val(feeAmount);
        });

        $('.fee-cover-field input').on('change', function () {
            updateDonationFeeAmount();
        });
    }

    $('.sitemap-list').masonry({
        itemSelector: '.sitemap-item',
        columnWidth: '.sitemap-item',
        percentPosition: true,
        horizontalOrder: false
    });

    $('.footer__sitemap--head').on('click', function () {
        $('.sitemap-list').toggle();
        $(this).toggleClass('active');

        $('.sitemap-list').masonry({
            itemSelector: '.sitemap-item',
            columnWidth: '.sitemap-item',
            percentPosition: true,
            horizontalOrder: false
        });

        // Animate scroll to top of header
        $("html, body").animate({
            scrollTop: $(this).offset().top - $header.outerHeight()
        }, 400);
    });
})(jQuery, window, document);
